import React from "react";
import { ToastContainer } from "react-toastify";

import TableWrapper from "@/utils/TableWrapper";
import type { TableWrapperProps } from "@/utils/TableWrapper";
import EditRoleContainer from "../EditRoleContainer";
import type {
  EditableUser,
  ListedUser,
  UsersListContainerProps,
} from "./UsersListContainer";

export type UsersListViewProps = {
  users: ListedUser[];
  columns: TableWrapperProps<ListedUser>["columns"];
  alert?: React.ReactNode;
  formModal: boolean;
  onToggleModal: (user?: EditableUser) => void;
  userUpdateRole: EditableUser;
  updateRoleHandler?: UsersListContainerProps["updateRoleHandler"];
};

/**
 * SCRUM-1141: the list renders through TableWrapper, so this view no longer
 * carries a pager or a hand-rolled `.slice()`. That slice, paired with a
 * `currentPage` the container never clamped when the list shrank, is what left
 * the table blank after deleting the last user on the last page — react-table
 * clamps the page index against its row model, so the state that could go stale
 * is gone rather than corrected.
 *
 * The permission gate now lives in the column definitions (the container builds
 * them), which is why this component no longer reads `permission` at all.
 */
const UsersListView = ({
  users,
  columns,
  alert,
  formModal,
  onToggleModal,
  userUpdateRole,
  updateRoleHandler,
}: UsersListViewProps) => (
  <>
    <div className="rna-wrapper">
      <ToastContainer />
    </div>
    {alert /* ReactBSAlert JSX créé côté container et passé ici */}

    <TableWrapper data={users} columns={columns} />

    <EditRoleContainer
      key={userUpdateRole?._id ?? "none"}
      formModal={formModal}
      toggleModal={onToggleModal}
      userToUpdate={userUpdateRole}
      userupdated={updateRoleHandler}
    />
  </>
);

export default UsersListView;
